import { faFacebook, faInstagram, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CommonService from "../services/common.service";

var common = new CommonService();

interface FooterProps {
}

interface FooterState {
    contactPhone: string;
    contactEmail: string;
    contactAddress: string;
    officeHours: Array<{ day: string, hours: string }>;
    socialLinks: Array<{ platformIcon: any, url: string }>;
    pageLinks: Array<{ label: string, link: string }>;
    dictionary?: Record<string, any>;
}

class PageFooter extends Component<FooterProps, FooterState> {
    constructor(props: FooterState) {
        super(props);
        this.state = {
            contactPhone: "",
            contactEmail: "",
            contactAddress: "",
            officeHours: [],
            socialLinks: [],
            pageLinks: []
        };
    }

    componentDidMount(): void {
        common.getLabels().then(translations => {
            this.setState({
                contactPhone: translations.filter((item: any) => item.setting_name === 'PHONE')[0].setting_value_text || "",
                contactEmail: translations.filter((item: any) => item.setting_name === 'EMAIL')[0].setting_value_text || "",
                contactAddress: translations.filter((item: any) => item.setting_name === 'ADDRESS')[0].setting_value_text || "",
                officeHours: [
                    { 
                        day: translations.filter((item: any) => item.setting_name === 'WEEKDAYS_LABEL')[0].setting_value_text || "", 
                        hours: translations.filter((item: any) => item.setting_name === 'OPEN_WEEKDAYS')[0].setting_value_text || "" 
                    },
                ],
                socialLinks: [
                    { platformIcon: faFacebook, url: translations.filter((item: any) => item.setting_name === 'FACEBOOK')[0].setting_value_text || "" },
                    { platformIcon: faInstagram, url: translations.filter((item: any) => item.setting_name === 'INSTAGRAM')[0].setting_value_text || "" },
                    { platformIcon: faTiktok, url: translations.filter((item: any) => item.setting_name === 'TIKTOK')[0].setting_value_text || "" },
                ],
                pageLinks: [
                    { label: translations.filter((item: any) => item.setting_name === 'ABOUT_US')[0].setting_value_text || "", link: "/about-us" },
                    { label: translations.filter((item: any) => item.setting_name === 'CONTACT')[0].setting_value_text || "", link: "/contact-us" },
                    { label: translations.filter((item: any) => item.setting_name === 'POLICY')[0].setting_value_text || "", link: "/privacy-policy" },
                    { label: translations.filter((item: any) => item.setting_name === 'TERMS')[0].setting_value_text || "", link: "/terms-and-conditions" },
                ],
                dictionary: translations
            });
        });
    }

    private navigatePage(url: string) {
        window.location.href = url;
    }

    render() {
        return (
            <Container fluid className="p-3 bg-danger text-white text-center oc-footer">
                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <h3 className="oc-title">{this.state?.dictionary?.filter((item: any) => item.setting_name === 'LABEL-GET-IN-TOUCH')[0].setting_value_text}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col lg={3} md={6} sm={12} xs={12} className="text-start">
                        <h4>{this.state?.dictionary?.filter((item: any) => item.setting_name === 'LABEL-CONTACT-INFORMATIONS')[0].setting_value_text}</h4>
                        <p className="oc-footer-link">{this.state.contactPhone}</p>
                        <p className="oc-footer-link">{this.state.contactEmail}</p>
                        <p className="oc-footer-link">{this.state.contactAddress}</p>
                    </Col>
                    <Col lg={3} md={6} sm={12} xs={12} className="text-start">
                        <h4>{this.state?.dictionary?.filter((item: any) => item.setting_name === 'LABEL-OFFICE-HOURS')[0].setting_value_text}</h4>
                        {this.state.officeHours.map((item, index) => (
                            <p key={index} className="oc-footer-text">{item.day}: {item.hours}</p>
                        ))}
                    </Col>
                    <Col lg={3} md={6} sm={12} xs={12} className="text-start">
                        <h4>{this.state?.dictionary?.filter((item: any) => item.setting_name === 'LABEL-FOLLOW-US')[0].setting_value_text}</h4>
                        {this.state.socialLinks.map((item, index) => (
                            <FontAwesomeIcon key={index} icon={item.platformIcon as any} className="me-2" onClick={() => this.navigatePage(item.url)} style={{ cursor: 'pointer' }}></FontAwesomeIcon>
                        ))}
                    </Col>
                    <Col lg={3} md={6} sm={12} xs={12} className="text-start">
                        {this.state.pageLinks.map((item, index) => (
                            <p key={index} className="oc-footer-link" onClick={() => this.navigatePage(item.link)}>{item.label}</p>
                        ))}
                        <p className="oc-footer-text">version {this.state?.dictionary?.filter((item: any) => item.setting_name === 'VERSION')[0].setting_value_text}</p>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default PageFooter;